export enum CustomerType {
	END_CUSTOMER = "END_CUSTOMER",
	RESELLER = "RESELLER",
}
